import { Component, computed, effect, inject, input, signal } from '@angular/core';
import { LpCanvasService } from '@core/lp/lp-canvas.service';
import { LpActionsService } from '@features/lp/lp-actions/lp-actions.service';
import { LpCanvasRendererComponent } from '@features/lp/lp-canvas/lp-canvas-renderer/lp-canvas-renderer.component';
import { LpTriggersService } from '@features/lp/lp-triggers/lp-triggers.service';
import { workaroundCanvasRatio } from '@shared/workarounds.utils';
import { LpCanvasElement, LpCanvasMap } from '@typings/lp/generated';

@Component({
  selector: 'lp-canvas-map',
  imports: [LpCanvasRendererComponent],
  templateUrl: './lp-canvas-map.component.html',
  styleUrl: './lp-canvas-map.component.css',
})
export class LpCanvasMapComponent {
  readonly #lpCanvasService = inject(LpCanvasService);
  readonly #lpActionsService = inject(LpActionsService);
  readonly #lpTriggersService = inject(LpTriggersService);

  map = input.required<LpCanvasMap>();
  elements = signal<LpCanvasElement[]>([]);
  size = computed(() => workaroundCanvasRatio(this.map().canvasRatio));

  constructor() {
    effect(async () => {
      this.#lpCanvasService.subscribeToShowIfChanges();

      this.elements.set([
        this.#lpCanvasService.convertBackgroundToElement(this.map().background, this.size()),
        ...this.map().canvasElements,
      ]);
    });

    effect(async () => {
      const map = this.map();

      queueMicrotask(async () => {
        await this.#lpTriggersService.on(map.onTrigger);
        await this.#lpActionsService.perform(map.onActivate);
      });
    });
  }
}
